import { forwardRef, type Ref, type SVGProps } from "react";
const IconErrorFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.444 3a2 2 0 0 0-1.415.586l-6.443 6.443A2 2 0 0 0 3 11.444v9.112a2 2 0 0 0 .586 1.415l6.443 6.443a2 2 0 0 0 1.415.586h9.112a2 2 0 0 0 1.415-.586l6.443-6.443A2 2 0 0 0 29 20.556v-9.112a2 2 0 0 0-.586-1.415l-6.443-6.443A2 2 0 0 0 20.556 3zM18 9.19 17.2 17a1.22 1.22 0 0 1-2.4 0L14 9.19a2 2 0 1 1 4 0M16 24a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconErrorFilledSVG);
ForwardRef.displayName = "IconErrorFilled";
export { ForwardRef as IconErrorFilled };
